import { render, staticRenderFns } from "./ApiUserForm.vue?vue&type=template&id=4037fe12&scoped=true&"
import script from "./ApiUserForm.vue?vue&type=script&lang=js&"
export * from "./ApiUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4037fe12",
  null
  
)

export default component.exports